module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/google-d7988cfa1fd0a2196b1c22439ebd4b7f.svg";